import { render, staticRenderFns } from "./MailDetailBody.vue?vue&type=template&id=71a6b4eb&"
import script from "./MailDetailBody.vue?vue&type=script&lang=ts&"
export * from "./MailDetailBody.vue?vue&type=script&lang=ts&"
import style0 from "./MailDetailBody.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports